exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pui-table__cell[data-v-8f7c92f4]{position:relative}\n", ""]);

